<script lang="ts">
    import { run } from 'svelte/legacy';

    import { createEventDispatcher } from 'svelte';
    import type { InputBWQueryDefinition } from 'header/types';
    import { BWQuerySystem } from '@bayer-int/portletce-shared';

    type FieldValue = InputBWQueryDefinition['value'];

    interface Props {
        field: InputBWQueryDefinition;
    }

    let { field }: Props = $props();

    const DEFAULT_SYSTEM = BWQuerySystem.H2R;

    let queryId: string = $state('');
    run(() => {
        queryId = field.value?.queryId ?? '';
    });
    let system: string = $state(DEFAULT_SYSTEM);
    run(() => {
        system = field.value?.system ?? DEFAULT_SYSTEM;
    });

    const dispatch = createEventDispatcher();

    const onQueryIdChange = (e: { currentTarget: HTMLInputElement }) => {
        queryId = e.currentTarget.value;
    };
    const onSystemChange = (e: { currentTarget: HTMLSelectElement }) => {
        system = e.currentTarget.value;
    };

    const submit = () => {
        const newValue: FieldValue = { queryId, system };
        dispatch('change', {
            field: {
                ...field,
                value: newValue,
            },
        });
    };
</script>

<div class="field">
    <input
        class="field--input"
        type="text"
        placeholder="Query id"
        disabled={field.changeable === false}
        value={queryId}
        oninput={onQueryIdChange}
    />
    <select
        class="field--select"
        onchange={onSystemChange}
        disabled={field.changeable === false}
        value={system}
    >
        {#each field.systems as system (system)}
            <option value={system}>{system}</option>
        {/each}
    </select>
</div>
<button class="button" disabled={field.changeable === false} onclick={submit}>apply</button>

<style lang="scss" scoped>
    .field {
        display: flex;

        &--input {
            flex: 3;
            margin-left: 0;
            margin-right: 2px;
        }
        &--select {
            flex: 1;
        }
    }
    .button {
        width: 100%;
    }
</style>
